import { reviewTypes } from '../types';

const initialState = {
    productId: null,
    quality: null,
    price: null,
    trueDesc: null,
    productReview: null,
    products: null,
    loading: true,
    error: null,
    insideLoading: false,
};

export const review = (state = initialState, action) => {
    switch (action.type) {
        case reviewTypes.ADD_REQUEST:
            return {
                ...state,
                errror: null,
                insideLoading: true,
                productId: action.productId,
            };
        case reviewTypes.ADD_SUCCESS:
            return {
                ...state,
                insideLoading: false,
                ...action.review,
            };
        case reviewTypes.ADD_ERROR:
            return {
                ...state,
                insideLoading: false,
                error: action.error,
            };
        case reviewTypes.REMOVE:
            return {
                ...state,
                products: state.products && state.products.filter((item) => action.productId !== item.id),
            };

        case reviewTypes.LOAD_REQUEST:
            return {
                ...state,
                loading: true,
                review: null,
                products: null,
            };
        case reviewTypes.LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.payload
            };
        case reviewTypes.LOAD_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};
